import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default function initGsapFullscreenPagesCta() {
    const sections = document.querySelectorAll('[data-fullscreen-pages-cta]');

    sections.forEach(section => {
        const bgItems = section.querySelectorAll('.fullscreen-pages-cta__bg-item');
        const cardImages = section.querySelectorAll('.fullscreen-pages-cta__card-image');
        const titles = section.querySelectorAll('.page-title');
        const indices = section.querySelectorAll('.current-index');
        
        const totalSlides = bgItems.length;
        if (totalSlides <= 1) return;

        // 1. Initial States (Clean & Simple)
        // Backgrounds: Stacked by index
        gsap.set(bgItems, { zIndex: i => i });
        gsap.set(bgItems[0], { opacity: 1 });
        gsap.set([...bgItems].slice(1), { opacity: 0 });
        
        // Cards: Only first visible
        gsap.set(cardImages, { autoAlpha: 0 });
        gsap.set(cardImages[0], { autoAlpha: 1 });

        // Titles: Only first visible, slight offset for movement
        gsap.set(titles, { autoAlpha: 0, y: 20 });
        gsap.set(titles[0], { autoAlpha: 1, y: 0 });

        // Indices: Only first visible
        gsap.set(indices, { autoAlpha: 0 });
        gsap.set(indices[0], { autoAlpha: 1 });

        // 2. Timeline (Linear & Synchronized)
        // We want a long "hold" phase and a fast "transition" phase.
        // Each step is 1 unit of time. 
        // Hold: 0.0 to 0.8 (80%)
        // Transition: 0.8 to 1.0 (20%)
        const tl = gsap.timeline({
            defaults: { ease: "none", duration: 0.2 } 
        });

        for (let i = 0; i < totalSlides - 1; i++) {
            const next = i + 1;
            const startTime = i + 0.8; // Start transition late in the cycle
            
            // Backgrounds: Next fades in (on top of current)
            tl.to(bgItems[next], { opacity: 1 }, startTime);

            // Cards: Crossfade + subtle zoom
            // Current: fade out y hacer un pequeño zoom-out
            tl.to(cardImages[i], { autoAlpha: 0, scale: 0.96 }, startTime);

            // Next: entra desde un ligero zoom-in y se normaliza
            tl.fromTo(
                cardImages[next],
                { autoAlpha: 0, scale: 1.04 },
                { autoAlpha: 1, scale: 1 },
                startTime
            );

            // Titles: Crossfade with subtle slide
            tl.to(titles[i], { autoAlpha: 0, y: -20 }, startTime);
            tl.to(titles[next], { autoAlpha: 1, y: 0 }, startTime);

            // Indices: Crossfade
            tl.to(indices[i], { autoAlpha: 0 }, startTime);
            tl.to(indices[next], { autoAlpha: 1 }, startTime);
        }

        // Extra hold on the last slide so it stays visible
        // a bit longer before unpinning.
        tl.to({}, { duration: 0.4 }, totalSlides - 1);

        // 3. ScrollTrigger (Pure Scrub)
        ScrollTrigger.create({
            trigger: section,
            start: "top top",
            end: `+=${totalSlides * 100}%`,
            pin: true,
            scrub: true, // Direct link to scrollbar, no smoothing lag
            animation: tl,
            onRefresh: self => {
                if (self.pinSpacer) {
                    self.pinSpacer.style.backgroundColor = "#000";
                }
            }
        });
    });
}
